import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "card-header pt-5" }
const _hoisted_2 = { class: "card-body d-flex flex-column align-items-end pt-0" }
const _hoisted_3 = { class: "d-flex justify-content-between" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_progress = _resolveComponent("el-progress")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["card card-flush bgi-no-repeat bgi-size-contain bgi-position-x-end border", _ctx.widgetClasses])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h4", null, _toDisplayString(_ctx.title), 1)
    ]),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.itemsList, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: _normalizeClass(["w-100", index == (_ctx.itemsList.length -1) ? '' : 'mb-4'])
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("span", null, _toDisplayString(item.name), 1),
            _createElementVNode("span", null, _toDisplayString(item.quantity), 1)
          ]),
          _createVNode(_component_el_progress, {
            percentage: item.quantity,
            status: item?.params,
            color: item?.param2
          }, null, 8, ["percentage", "status", "color"])
        ], 2))
      }), 128))
    ])
  ], 2))
}